// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2_i-_","subheader":"ReorderModal_subheader__1jz6A","listWrap":"ReorderModal_listWrap__3SqEx"};